import { ClipboardList, MapPin } from 'lucide-react';
import { ASSIGNED_JOBS, JOB_STATUS } from './mockVendorData';

function StatusBadge({ status }) {
  const config = JOB_STATUS[status];
  return (
    <span
      className={`inline-flex whitespace-nowrap rounded-full px-2.5 py-0.5 text-[10px] font-bold uppercase ring-1 ${config.className}`}
    >
      {config.label}
    </span>
  );
}

export default function AssignedJobsLedger({ jobs = ASSIGNED_JOBS }) {
  const pendingCount = jobs.filter((j) => j.status === 'pending').length;

  return (
    <section className="overflow-hidden rounded-xl border border-logi-grid bg-white backdrop-blur-sm">
      <div className="flex flex-wrap items-center justify-between gap-3 border-b border-logi-grid px-4 py-3">
        <div className="flex items-center gap-2">
          <ClipboardList className="h-4 w-4 text-indigo-400" strokeWidth={1.75} />
          <div>
            <h3 className="text-sm font-bold text-logi-text">Assigned Jobs Ledger</h3>
            <p className="text-[11px] text-logi-text0">Dispatcher-assigned consignments</p>
          </div>
        </div>
        {pendingCount > 0 && (
          <span className="rounded-full bg-amber-50 px-2.5 py-1 text-xs font-bold text-amber-700 ring-1 ring-amber-500/25">
            {pendingCount} pending acceptance
          </span>
        )}
      </div>

      <div className="overflow-x-auto">
        <table className="w-full min-w-[800px] text-left text-sm">
          <thead>
            <tr className="border-b border-logi-grid/80 bg-white text-[10px] uppercase tracking-wider text-logi-text0">
              <th className="px-4 py-2.5 font-semibold">Job ID</th>
              <th className="px-4 py-2.5 font-semibold">Route</th>
              <th className="px-4 py-2.5 font-semibold">Product</th>
              <th className="px-4 py-2.5 font-semibold">Volume</th>
              <th className="px-4 py-2.5 font-semibold">Rate</th>
              <th className="px-4 py-2.5 font-semibold">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-logi-grid/30">
            {jobs.map((job) => (
              <tr key={job.id} className="transition-colors hover:bg-logi-silver">
                <td className="px-4 py-2.5">
                  <span className="font-mono font-semibold text-indigo-400">{job.id}</span>
                  <p className="text-[10px] text-logi-text0">{job.assignedDate}</p>
                </td>
                <td className="px-4 py-2.5">
                  <span className="inline-flex items-center gap-1 text-xs text-logi-muted">
                    <MapPin className="h-3 w-3 text-logi-text0" />
                    {job.route}
                  </span>
                </td>
                <td className="px-4 py-2.5 text-logi-muted">{job.product}</td>
                <td className="px-4 py-2.5 font-mono text-xs font-semibold text-amber-700/90">
                  {job.volume}
                </td>
                <td className="px-4 py-2.5 font-mono text-xs text-logi-muted">
                  {job.rateAed.toLocaleString()} AED
                </td>
                <td className="px-4 py-2.5">
                  <StatusBadge status={job.status} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
